"use client";

import { resolveNumber } from "./binding";
import type { MacaronRenderContext, RecordAny } from "./types";

function normalizeZoom(value: number) {
  if (!Number.isFinite(value)) return 14;
  return Math.max(1, Math.min(21, value));
}

export function MacaronMap({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const latitude = resolveNumber(config.latitude, ctx.data);
  const longitude = resolveNumber(config.longitude, ctx.data);
  const zoom = normalizeZoom(resolveNumber(config.zoom, ctx.data));
  const hasLocation = Number.isFinite(latitude) && Number.isFinite(longitude);

  return (
    <div className="w-full overflow-hidden rounded-xl border border-[#D0D5DD] bg-[#F8FAFC]">
      <div className="aspect-[1.8] w-full">
        {hasLocation ? (
          <iframe
            title="Map"
            className="h-full w-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://maps.google.com/maps?q=${latitude},${longitude}&z=${zoom}&output=embed`}
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-[#F8FAFC] text-sm font-semibold text-[#8A8A86]">Coordinates unavailable</div>
        )}
      </div>
    </div>
  );
}
